import guid from 'uuid';

import { DocumentsSource, EntityType } from 'const';
import { TextComponent } from 'models';
import { removeTags } from 'utils/html';

export function textComponentFactory({
  id = guid(),
  text = '',
  status = null,
  rawContent = '',
  lexicalState = null,
  name = removeTags(text),
  documentSource = [DocumentsSource.ONLINE],
  language = [],
  country = [],
  referenceCitations = [],
  translatable = true,
  hasProjectMetadataToken,
} = {} as Partial<TextComponent>): TextComponent {
  return {
    id,
    text,
    entityType: EntityType.TEXT,
    language,
    country,
    name,
    documentSource,
    status,
    rawContent,
    lexicalState,
    referenceCitations,
    translatable,
    hasProjectMetadataToken,
  };
}
